module.exports = __webpack_public_path__ + "img/20180815_150347_072.7a9118c8.jpg";